import React from "react";
import { anyNotifyChannelEnabled } from "../notifySettings";

/**
 * Opt-in checkboxes gated by site_settings flags.
 * Email is independent; SMS and WhatsApp are mutually exclusive.
 */
const NotifyOptIn = ({
  channels,
  email,
  phoneChannel,
  onEmailChange,
  onPhoneChannelChange,
  disabled,
}) => {
  if (!anyNotifyChannelEnabled(channels)) return null;

  const showSms = channels.sms === true;
  const showWhatsapp = channels.whatsapp === true;
  const showPhoneGroup = showSms || showWhatsapp;

  return (
    <div className="reg-notify">
      <div className="reg-label">Avisos (opcional)</div>
      <p className="reg-hint">
        Elige cómo quieres recibir avisos de la liga. Puedes marcar correo y,
        si está disponible, SMS o WhatsApp (solo uno).
      </p>

      <div className="reg-notify-options">
        {channels.email === true && (
          <label className="reg-notify-option">
            <input
              type="checkbox"
              checked={Boolean(email)}
              onChange={(e) => onEmailChange(e.target.checked)}
              disabled={disabled}
            />
            <span>Correo electrónico</span>
          </label>
        )}

        {showPhoneGroup && (
          <div
            className="reg-notify-phone"
            role="group"
            aria-label="Avisos por teléfono"
          >
            {showSms && (
              <label className="reg-notify-option">
                <input
                  type="checkbox"
                  checked={phoneChannel === "sms"}
                  onChange={(e) =>
                    onPhoneChannelChange(e.target.checked ? "sms" : "")
                  }
                  disabled={disabled}
                />
                <span>SMS</span>
              </label>
            )}
            {showWhatsapp && (
              <label className="reg-notify-option">
                <input
                  type="checkbox"
                  checked={phoneChannel === "whatsapp"}
                  onChange={(e) =>
                    onPhoneChannelChange(e.target.checked ? "whatsapp" : "")
                  }
                  disabled={disabled}
                />
                <span>WhatsApp</span>
              </label>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotifyOptIn;
